export default __webpack_public_path__ + "static/media/coderedimg.e32760d5.png";